import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getEnvironmentColor(environment?: string): string {
  if (!environment) return "#6B7280" // gray-500

  switch (environment.toLowerCase()) {
    case "production":
      return "#DC2626" // red-600
    case "staging":
      return "#EA580C" // orange-600
    case "development":
      return "#2563EB" // blue-600
    default:
      return "#6B7280" // gray-500
  }
}

export function formatBytes(bytes: number | null | undefined, decimals: number = 0): string {
  if (!bytes) return "N/A"
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"]
  if (bytes === 0) return "0 Bytes"
  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  return parseFloat((bytes / Math.pow(1024, i)).toFixed(decimals)) + " " + sizes[i]
}
